import React, {useEffect} from 'react';
import useRedux from 'infrastructure/js/hooks/useRedux';
import useLabels from 'infrastructure/js/hooks/useLabels';
import Header, {headerItemsLabels} from '../../../Common/Header/header';
import {MatSettingsMenuItemsIds} from '../../../../enums/navigationMenuItemsIds';
import {gridsNames} from '../../../../enums/gridsNames.js';
import QplsActivityLogViewGrid from './QplsActivityLogViewGrid/qplsActivityLogViewGrid';
import {jsxActions as headerSettingsActions} from '../../../../actions/Header/headerSettingsActions';
import {jsxActions as qplsActivityLogViewActions } from '../../../../actions/Administration/MatSettingsPage/qplsActivityLogViewActions';
import {jsxActions as qplsActivityLogViewGridActions} from '../../../../actions/Administration/MatSettingsPage/qplsActivityLogViewGridActions';
import {jsxActions as fetchEntitiesActions} from '../../../../actions/FetchEntities/fetchEntitiesActions';
import { jsxActions as matSettingsPageActions } from '../../../../actions/Administration/MatSettingsPage/matSettingsPageActions.js';



const getState = (state) => {
  let grid = state.grid?.get(gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS_ACTIVITY_LOG) || null;

  return {
    sHasRows: grid?.get('rows')?.size > 0 || false,
  };
};

const allActions = {
  headerSettingsActions,
  qplsActivityLogViewActions,
  qplsActivityLogViewGridActions,
  fetchEntitiesActions,
  matSettingsPageActions: matSettingsPageActions,
};

export default function QplsActivityLogView(props) {

  const labels = useLabels('mat.administration.matsettings.qplsActivityLog.view.');
  const { state, actions } = useRedux(allActions, getState);


  useEffect(() => {
    actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_QPLS_ACTIVITY_LOG);
  }, []);


  const getHeaderItems = () => {

    return  {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.qplsActivityLogViewActions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: actions.qplsActivityLogViewActions.reload,
          tooltip: headerItemsLabels.REFRESH,
        },
        ],
      kebab: {}
    };
  }

  return (
    <div className="administration-view">
      <div className="title">{labels.get('title')}</div>

      <Header {...getHeaderItems()}/>

      <QplsActivityLogViewGrid actions={{...actions.qplsActivityLogViewGridActions, ...actions.fetchEntitiesActions}} />

    </div>
  )
}
